import React, { Component } from 'react';
/* eslint-disable */
import ReactDOM from 'react-dom';
import Notifications, { notify } from 'react-notify-toast';
import EditableLabel from 'react-inline-editing';
import axios from 'axios';
import { MY_API_URL } from '../../../Apanel/QueryMe';
import DeleteIcon from 'mdi-react/DeleteIcon';
import Alert from '../../../../shared/components/Alert';
import swal from 'sweetalert';
const apiurl = MY_API_URL;
import {
	Card,
	CardBody,
	Col,
	Table,
	Button,
	ButtonGroup,
	ButtonToolbar,
	Modal,
	ListGroup,
	ListGroupItem,
	Badge,
	Input,
} from 'reactstrap';
const initialstate = {
	showAlert: false,
	alertType: '',
	alertText: '',

	token: localStorage.token,
	options: [],
	editoptions: [],
	technologySelected: '',
	editquesid: '',
	editquestion: '',
	editoptionA: '',
	editoptionB: '',
	editoptionC: '',
	editoptionD: '',
	editcorrectAnswer: '',
	question: '',
	optionA: '',
	optionB: '',
	optionC: '',
	optionD: '',
	correctAnswer: '',
	enterques: false,
	questype: 0,
	questypename: '',
	testname: '',
	newtestname: '',
	testid: localStorage.custestid,
	editOpModal: false,
	showtickets: 1,
};
class AddQuest extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'addquest');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			if (localStorage.custestid) {
				this.handleGetTest(localStorage.custestid);
			} else {
				this.createTestName();
			}
		}
	}
	_handleFocus(noorid, tfor, opt, text) {
		console.log(text);
		console.log(
			'Focused with: ' +
				text +
				' noorid:' +
				noorid +
				' tfor:' +
				tfor +
				' opt:' +
				opt,
		);
		this.setState({
			edittestid: tfor,
			oldkeyname: text,
			noorid: noorid,
		});
	}

	_handleFocusOut(noorid, tfor, opt, newkeyname) {
		console.log(
			'Left editor with: ' +
				newkeyname +
				' noorid:' +
				noorid +
				' tfor:' +
				tfor +
				' opt:' +
				opt,
		);
		console.log('edittestid', this.state.edittestid);
		console.log('oldkeyname', this.state.oldkeyname);
		console.log('noorid', this.state.noorid);
		if (noorid == this.state.noorid) {
			if (newkeyname == this.state.oldkeyname) {
				console.log('no change');
			} else {
				// post started
				let editkeyurl = '';
				if (tfor == 'testname') {
					editkeyurl = apiurl + 'editmytest';
					var postData = {
						noorid: noorid,
						testname: newkeyname,
					};
				} else if (tfor == 'quesname') {
					editkeyurl = apiurl + 'editmyques';
					var postData = {
						noorid: noorid,
						quesname: newkeyname,
						testid: localStorage.custestid,
					};
				} else if (tfor == 'opt') {
					console.log('opt change');
					editkeyurl = apiurl + 'editmyquesopt';
					var postData = {
						noorid: noorid,
						optext: newkeyname,
						opt: opt,
						testid: localStorage.custestid,
					};
				}
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				axios
					.post(editkeyurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);
						if (response.data.error) {
							notify.show(
								newkeyname + ' ' + response.data.message,
								'warning',
								3000,
								'',
							);
							window.location.reload(false);
						} else {
							notify.show(
								newkeyname + ' ' + response.data.message,
								'success',
								3000,
								'',
							);
						}
					});
				//post ended
			}
		}
	}

	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
	};

	handleSelectQuesType = (quesid, e) => {
		let questype = e.target.value;
		console.log('quesid', quesid);
		console.log('questype', questype);
		let questypename = '';
		let optionss = [];
		if (questype == 1) {
			questypename = 'Multiple choice';
			optionss.push('Option A');
			optionss.push('Option B');
			optionss.push('Option C');
			optionss.push('Option D');
		} else if (questype == 2) {
			questypename = 'True or False';
			optionss.push('True');
			optionss.push('False');
			optionss.push('');
			optionss.push('');
		} else if (questype == 3) {
			questypename = 'Paragraph';
			optionss.push('');
			optionss.push('');
			optionss.push('');
			optionss.push('');
		}
		this.handleQuestionEditSubmit(optionss, quesid, questype, questypename);
	};
	handleQuestionEditSubmit = (optionss, quesid, questype, questypename) => {
		console.log('OPTIONS ARRAY IS ', optionss);

		this.setState(
			{
				editoptions: [...optionss],
			},
			() => {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const addsqurl = apiurl + 'chngMyOwnMQues';
				var postData = {
					options: [...this.state.editoptions],
					answer: 0,
					questype: questype,
					questypename: questypename,
					quesid: quesid,
					email: localStorage.viewrecruiter,
					testid: localStorage.custestid,
				};
				axios
					.post(addsqurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);
						if (response.data.error) {
							this.setState({
								showAlert: true,
								alertType: 'danger',
								alertText: response.data.message,
							});
						} else {
							this.setState({
								editOpModal: false,
								showAlert: false,

								questions: [...response.data.testques],

								questype: 0,
								questypename: '',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						this.setState({
							alertType: 'danger',
							showAlert: true,
							alertText: 'Failed Try Again Later!',
						});
					});
			},
		);
	};
	handleComplete = () => {
		swal({
			title: 'Save: ' + this.state.newtestname,
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const togkeyurl = apiurl + 'savecustumtest';
				var postData = {
					quesid: localStorage.custestid,
					email: localStorage.viewrecruiter,
				};
				axios
					.post(togkeyurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(response.data.message, {
								icon: 'warning',
							});
						} else {
							swal(response.data.message, {
								icon: 'success',
							});
							localStorage.setItem('custestid', '');
							this.props.history.push('/recruiter/customsavedtest');
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};
	handleExit = () => {
		localStorage.setItem('custestid', '');
		this.props.history.push('/recruiter/mycustoms');
	};
	handleSingleSubmit = () => {
		let correctAnswer = 0;
		let optionss = [];
		let questypename = 'Multiple choice';
		let questype = 1;
		optionss.push('Option A');
		optionss.push('Option B');
		optionss.push('Option C');
		optionss.push('Option D');
		console.log('OPTIONS ARRAY IS ', optionss);

		this.setState(
			{
				options: [...optionss],
			},
			() => {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const addsqurl = apiurl + 'addMyOwnMQues';
				var postData = {
					options: [...this.state.options],
					email: localStorage.viewrecruiter,
					question: 'Question',
					answer: correctAnswer,
					questype: questype,
					questypename: questypename,
					testid: localStorage.custestid,
				};
				axios
					.post(addsqurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);
						if (response.data.error) {
							this.setState({
								showAlert: true,
								alertType: 'danger',
								alertText: response.data.message,
							});
						} else {
							this.setState({
								enterques: false,
								showAlert: false,
								question: '',
								options: [],
								optionA: '',
								optionB: '',
								optionC: '',
								optionD: '',
								correctAnswer: '',
								questions: [...response.data.testques],

								questype: 0,
								questypename: '',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						this.setState({
							alertType: 'danger',
							showAlert: true,
							alertText: 'Failed Try Again Later!',
						});
					});
			},
		);
	};

	createTestName = () => {
		event.preventDefault();

		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		let uploadurl = 'createMyTestName';

		const addsqurl = apiurl + uploadurl;
		var postData = {
			testname: 'New Test Name',
			email: localStorage.viewrecruiter,
		};
		axios
			.post(addsqurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
						testid: 0,
					});
				} else {
					console.log(response.data.data);
					localStorage.setItem('custestid', response.data.data[0].id);
					this.setState(
						{
							showAlert: false,
							enterques: false,
							questype: 0,
							questypename: '',
							testid: response.data.testid,
						},
						() => {
							console.log(response.data.data[0].testname);
							this.setState({
								newtestname: response.data.data[0].testname,
								questions: [...response.data.testques],
							});
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};
	handleGetTest = (testid) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			email: localStorage.viewrecruiter,
			testid: testid,
		};
		const getfqurl = apiurl + 'getmytestid';
		axios
			.post(getfqurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					console.log(response.data.data[0].testname);
					this.setState({
						newtestname: response.data.data[0].testname,
						questions: [...response.data.testques],
					});
				}
			})
			.catch((error) => {
				this.props.history.push('/recruiter/dashboard');
			});
	};
	handlechngAnswer = (quesid, oans, qans, id) => {
		console.log(quesid + 'quesid');
		console.log(id + 'id');
		console.log(qans + 'qans');
		if (oans == qans) {
		} else {
			swal({
				title: 'Change Answer',
				text: 'Are you sure?',
				icon: 'warning',
				buttons: true,
				dangerMode: true,
			}).then((keyconfirm) => {
				if (keyconfirm) {
					const headers = {
						'Content-Type': 'application/json',
						Authorization: localStorage.token,
					};

					const togkeyurl = apiurl + 'changeOption';
					var postData = {
						quesid: quesid,
						qans: qans,
					};
					axios
						.post(togkeyurl, postData, {
							headers: headers,
						})
						.then((response) => {
							console.log(response.data.message);

							if (response.data.error) {
								notify.show(response.data.message, 'warning', 3000, '');
							} else {
								this.handleGetTest(localStorage.custestid);

								notify.show(response.data.message, 'success', 3000, '');
							}
						})
						.catch((error) => {
							console.log('Error is ', error);
							swal('Try Again Later', {
								icon: 'Danger',
							});
						});
				}
			});
		}
	};
	handleDelQues = (quesid, id) => {
		console.log(quesid + 'quesid');

		swal({
			title: 'Want to Delete',
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const togkeyurl = apiurl + 'managemyquestion';
				var postData = {
					quesid: quesid,
				};
				axios
					.post(togkeyurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(response.data.message, {
								icon: 'warning',
							});
						} else {
							this.handleGetTest(localStorage.custestid);
							swal(response.data.message, {
								icon: 'success',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};
	render() {
		const {
			editoptionA,
			editoptionB,
			editoptionC,
			editoptionD,
			question,
			optionA,
			optionB,
			optionC,
			optionD,
			testname,
			newtestname,
			showtickets,
		} = this.state;
		const questiontypes = [
			{ value: '1', label: 'Multiple choice' },
			{ value: '2', label: 'True or False' },
			{ value: '3', label: 'Paragraph' },
		];
		return (
			<div>
				<Notifications />
				{this.state.newtestname ? (
					<Col md={8}>
						<Card>
							<CardBody>
								<h5 className="bold-text">
									<Button
										className="float-right btn-sm"
										color="success"
										onClick={this.handleSingleSubmit}
									>
										+
									</Button>
									Test Name:{' '}
									<EditableLabel
										text={this.state.newtestname}
										labelClassName="myLabelClass myeditbox"
										inputClassName="myInputClass"
										inputWidth="90%"
										inputHeight="25px"
										labelFontWeight="bold"
										inputFontWeight="bold"
										data-option="0"
										onFocus={this._handleFocus.bind(
											this,
											localStorage.custestid,
											'testname',
											'opt',
										)}
										onFocusOut={this._handleFocusOut.bind(
											this,
											localStorage.custestid,
											'testname',
											'opt',
										)}
									/>
								</h5>
							</CardBody>
						</Card>
					</Col>
				) : null}
				{this.state.questions &&
					this.state.questions.map((ques, index) => {
						return (
							<div className="col-md-8" key={index}>
								<div className="row">
									<div className="col-md-12">
										<div className="grid card">
											<div className="card-body">
												<Badge className="qtypename" color="primary">
													{ques.type}{' '}
												</Badge>
												<div className="questiontype">
													<Input
														type="select"
														name="questype"
														style={{ fontSize: '12px' }}
														onChange={this.handleSelectQuesType.bind(
															this,
															ques.id,
														)}
														defaultValue={ques.questype}
													>
														{questiontypes &&
															questiontypes.map((questiontype, index) => {
																return (
																	<option
																		key={index}
																		value={questiontype.value}
																	>
																		{questiontype.label}
																	</option>
																);
															})}
													</Input>
												</div>
												<span
													className="deleteques"
													onClick={this.handleDelQues.bind(this, ques.id)}
												>
													<DeleteIcon />
												</span>
												<h5
													className="bold-text"
													style={{ position: 'relative' }}
												>
													<span className="cusquestionic">Q:{index + 1}</span>
													<EditableLabel
														text={ques.question}
														labelClassName="myLabelClass myeditbox"
														inputClassName="myInputClass"
														inputWidth="90%"
														inputHeight="25px"
														labelFontWeight="bold"
														inputFontWeight="bold"
														onFocus={this._handleFocus.bind(
															this,
															ques.id,
															'quesname',
															'opt',
														)}
														onFocusOut={this._handleFocusOut.bind(
															this,
															ques.id,
															'quesname',
															'opt',
														)}
													/>
												</h5>
												<div className="clearfix"></div>
												{ques.questype == 1 ? (
													<div className="row">
														<div
															className={
																ques.correct == 0
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">A:</span>
															<EditableLabel
																text={ques.options[0]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	0,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	0,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 0 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	0,
																)}
															/>
															{ques.correct == 0 ? 'Ans' : null}
														</div>
														<div
															className={
																ques.correct == 1
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">B:</span>
															<EditableLabel
																text={ques.options[1]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	1,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	1,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 1 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	1,
																)}
															/>
															{ques.correct == 1 ? 'Ans' : null}
														</div>
														<div className="clearfix"></div>
														<div
															className={
																ques.correct == 2
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">C:</span>
															<EditableLabel
																text={ques.options[2]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	2,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	2,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 2 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	2,
																)}
															/>
															{ques.correct == 2 ? 'Ans' : null}
														</div>
														<div className="clearfix"></div>
														<div
															className={
																ques.correct == 3
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">D:</span>
															<EditableLabel
																text={ques.options[3]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	3,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	3,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 3 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	3,
																)}
															/>
															{ques.correct == 3 ? 'Ans' : null}
														</div>
														<div className="clearfix"></div>
													</div>
												) : null}
												{ques.questype == 2 ? (
													<div className="row">
														<div
															className={
																ques.correct == 0
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">A:</span>
															<EditableLabel
																text={ques.options[0]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	0,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	0,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 0 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	0,
																)}
															/>
															{ques.correct == 0 ? 'Ans' : null}
														</div>
														<div className="clearfix"></div>
														<div
															className={
																ques.correct == 1
																	? 'col-md-10 mycusoptionsuccess'
																	: 'col-md-10 mycusoptions'
															}
															style={{ position: 'relative' }}
														>
															<span className="cusoptionic">B:</span>
															<EditableLabel
																text={ques.options[1]}
																labelClassName="myLabelClass myeditbox"
																inputClassName="myInputClass"
																inputWidth="90%"
																inputHeight="25px"
																labelFontWeight="bold"
																inputFontWeight="bold"
																data-option="0"
																onFocus={this._handleFocus.bind(
																	this,
																	ques.id,
																	'opt',
																	1,
																)}
																onFocusOut={this._handleFocusOut.bind(
																	this,
																	ques.id,
																	'opt',
																	1,
																)}
															/>
														</div>
														<div className="col-md-1 anscusoptions">
															<Input
																type="radio"
																name={ques.id}
																checked={ques.correct == 1 ? 1 : 0}
																onChange={this.handlechngAnswer.bind(
																	this,
																	ques.id,
																	ques.correct,
																	1,
																)}
															/>
															{ques.correct == 1 ? 'Ans' : null}
														</div>
														<div className="clearfix"></div>
													</div>
												) : null}
												{ques.questype == 3 ? (
													<div className="row">
														<div className="col-md-10 mycusoptions">
															Test Taker Need to Write Answer
														</div>

														<div className="clearfix"></div>
													</div>
												) : null}
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					})}
				{this.state.newtestname && this.state.questions ? (
					<Col md={12}>
						<Card>
							<CardBody>
								<h5 className="bold-text">
									<Button
										className="btn-sm"
										color="primary"
										onClick={this.handleExit}
									>
										Exit
									</Button>
									<Button
										className="float-right btn-sm"
										color="success"
										onClick={this.handleComplete}
									>
										Finalise and Exit
									</Button>
								</h5>
							</CardBody>
						</Card>
					</Col>
				) : null}
			</div>
		);
	}
}

export default AddQuest;
